<!--常见问题-->
<template>
  <div class="comp-question">
    <!-- header头 -->
    <div class="header">
      <div class="back-btn" @click="goBack"><img src="@/assets/images/icon-back.png"></div>
      <div class="title">常见问题</div>
    </div>
    <!-- 内容区 -->
    <div class="cont">
        <div class="bd">
            <div class="pa-ins-faq">
              <dl>
                  <dt><em>Q</em><span>哪些慢病人群可以投保本产品？是否需要体检？</span></dt>
                  <dd>本产品共分为糖尿病版、高血压版、甲状腺结节版、其他慢病版4个计划，适用于不同的慢病人群（4个计划的保险责任和价格完全相同，适用的《健康告知》内容存在差异）：<br>
                  <b>糖尿病版</b>：适用于2型糖尿病患者；<br>
                  <b>高血压版：</b>适用于原发性高血压患者；<br>
                  <b>甲状腺结节版：</b>适用于甲状腺结节、甲亢、甲减患者；<br>
                  <b>其他慢病版：</b>适用于高血脂、中轻度脂肪肝、急性支气管炎、急性肺炎、已治愈肺结核、慢性咽炎、胆囊结石、胆囊炎、十二指肠溃疡、痛风、心脏神经官能症、泌尿系统结石、前列腺增生、前列腺囊肿、乳腺囊肿、二级及以下乳腺结节、宫颈炎（宫颈炎合并HPV感染、宫颈上皮内瘤变CIN除外）、阴道炎、盆腔炎、颈椎病、腰椎间盘突出等<a href="javascript:;" data-url="https://m.health.pingan.com/share/page/54/101.pdf" @click="goToThirdPage($event)">《可投保疾病清单》</a>中的其他慢病患者。<br>
                  投保本产品时不要求提交体检报告，但<b>您需要在投保时如实进行健康告知。如果您未如实告知，有可能不能获得赔付。</b></dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>本产品保什么？慢病既往症是否可以赔？</span></dt>
                <dd>本产品是针对亚健康及慢病人群设计开发的百万医疗保险， 包含200万一般医疗保险金和200万特定疾病医疗保险金，有无社保均可购买，免赔额2万元。保障范围内，不限社保用药，100%赔付比例；以有基本医疗保险或公费医疗身份投保，但在就诊治疗时未使用基本医疗保险或公费医疗的，赔付比例60%，赔付公式：赔款=（医疗费用-年免赔额）*60%。<br>
                对于投保时已经确诊、且不属于《健康告知》限制范围内的慢病既往症，保障范围内的医疗费用也可以报销。<br>
                此外，对于可选附加包：<br>
                质子重离子医疗附加包：保额100万元，无免赔额，无论是否使用社保报销，赔付比例100%。<br>
                恶性肿瘤特药附加包：保额150万元，无免赔额，赔付比例100%，已纳入社保目录的药品未使用社保报销的，赔付比例60%，赔付公式：赔款=（医疗费用-年免赔额）*60%。</dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>门急诊费用可以理赔吗?</span></dt>
                <dd>保障范围内，办理住院手续前30日内和办理出院手续后30日内，与该次住院相同原因而发生的，必须由被保险人自行承担的门诊急诊医疗费用（包括医生诊疗费、治疗费、检查检验费、药品费、救护车使用费）可以报销。<br>
                因疾病或意外伤害在医院进行的门诊手术、门诊肾透析，器官移植后的门诊抗排异治疗、门诊恶性肿瘤化疗/放疗/免疫治疗/内分泌治疗/靶向治疗的费用，也可报销。</dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>在哪些医院治疗可以获得理赔？</span></dt>
                <dd>在中华人民共和国境内（不含港、澳、台地区）二级以上（含二级）公立医院普通部及约定的医院接受住院、指定门诊、住院前后30天门急诊治疗的，可以报销个人支付的、必要且合理的医疗费用。<br>
                若您选择了质子重离子附加包，则在上海质子重离子医院，暨复旦大学附属肿瘤医院质子重离子中心，接受质子重离子治疗的，可以报销质子重离子放射治疗而发生的相关费用。</dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>什么是HelloRun Club？加入HelloRun Club有什么好处？</span></dt>
                <dd>HelloRun Club是平安健康推出的、以提高会员健康水平为目的的俱乐部，平安健康APP的注册会员均可加入。HelloRun Club会员可通过在平安健康APP完成健康任务获得健康信用。年龄在18周岁-70周岁之间且健康信用达标的HelloRun Club会员，在作为被保险人投保本产品时可根据相应的健康信用调整系数享受优惠费率（优惠幅度最高为30%）。具体优惠规则可点击<a href="javascript:;" data-url="https://m.health.pingan.com/share/page/45/101.html" @click="goToThirdPage($event)">《健康信用费率优惠》</a>。</dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>本产品满期之后，如何保障不受影响？</span></dt>
                <dd>本产品是一年期产品。保险期间届满后，若您要继续享有本产品提供的保障，请您在上一保险期间届满后60日内申请重新投保。<b>若保险期间届满时，本产品已停止销售，我们不再接受投保申请，但会向您提供投保其他保险产品的合理建议。</b></dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>什么是犹豫期？</span></dt>
                <dd>自您签收本合同或本合同电子保单次日起，有10日的犹豫期。在此期间，如果您提出解除保险合同，我们将无息退还您所支付的全部保险费。自收到您解除合同的申请时起，本合同即被解除，合同解除前发生的保险事故我们不承担保险责任。<b>犹豫期外退保，您会遭受一定的损失。</b></dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>什么是等待期？</span></dt>
                <dd>本保险等待期为自生效之日起30日。因遭受意外伤害事故进行治疗的无等待期。保险期间届满后，如果您选择重新投保，至期满后60日内投保，无等待期。<br>
                被保险人在等待期结束前被确诊罹患的疾病所导致的医疗费用，无论此等费用是否发生在等待期内，我们都不承担本主险合同所有保险金的赔付责任。<br>
                被保险人在投保后至等待期结束之日前罹患本主险合同所附特定疾病清单（详见条款附表2）定义的特定疾病的，我们不承担给付保险金的责任，合同终止，我们向您无息退还所有保险费。</dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>什么情况下是不赔付的？</span></dt>
                <dd><b>在保险条款中明确说明了不赔付的几种情况，详见《平安i康保个人（慢病版）医疗保险条款》 “2.2保险责任”、 “2.3责任免除”、“4.2保险事故通知”、“7.2年龄错误”、“8释义”及附表中背景突出显示的内容；《平安附加质子重离子医疗保险条款》“2.1等待期”、“2.2保险责任”、 “2.3责任免除”、“3.2保险事故的通知”、“6 其他需要关注的事项”、“7 释义”；《 平安特定恶性肿瘤药品费用医疗保险条款》“2.1保险责任”、 “2.2责任免除”、“3.2保险事故通知”、“6.2年龄错误”、“7释义”及附表中背景突出显示的内容。</b></dd>
              </dl>
              <dl>
                <dt><em>Q</em><span>本产品提供哪些医疗服务？</span></dt>
                <dd>委托第三方服务供应商为被保险人提供“私人健康顾问、家庭护理、恶性肿瘤国内二诊、住院就医安排”四项就医服务。<br>
                1.  <b>私人健康顾问：</b>针对糖尿病、高血压、高血脂、甲状腺结节等常见慢病，内分泌等多学科专家医生提供个性化指标监控、饮食调理、运动指导、用药方案、定期复查计划、检查报告解读等的一对一视频问诊服务，且如客户需送药上门，医生可为客户开具常用OTC药品电子处方，在客户付费后，安排药品邮寄给客户。<br>
                2.  <b>家庭护理：</b>客户因外伤或因病手术后在家休养，可为客户提供普通换药、外科拆线（7针以内）、雾化治疗、吸痰护理、打针5项家庭护理服务（每项限1次）。<br>
                3.  <b>恶性肿瘤国内二诊：</b>根据被保险人的疾病情况和就医需求，由专业的分诊医生协助被保险人根据需求预约全国肿瘤专家团队的专家提供专业书面的诊疗建议和治疗方案建议。<br>
                4.  <b>住院就医安排：</b>客户因患病需医院住院治疗时，为客户协调安排进行住院治疗。在客户获得并提供住院单后，为其安排主诊医生或优选推荐医生的住院床位，并在就诊过程中，由陪诊专员全程陪同，予以协助。<br>
                以上服务的详细说明、服务限制、服务流程及其他注意事项参见<a href="javascript:;" data-url="https://m.health.pingan.com/share/page/49/101.pdf" @click="goToThirdPage($event)">《服务手册》</a>。</dd>
              </dl>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'QuestionDetail',
  data() {
    return {
      name: 'i康保·百万医疗慢病版-问题详情',
      curIndex:0,
      isCur:0
    }
  },
  props: {
  },
  computed: {
    
  },
  methods: {
    goBack() {
      if (this.$store.state.preRoute) {
        this.$router.go(-1);
      } else {
        window.history.go(-1);
      } 
    },
    // 跳转到其他页面
    goToThirdPage(e) {
      let url = e.target.getAttribute('data-url');
      let title = e.target.text || '';
      this.$router.push({
        name: 'ThirdPage',
        query: {
          url: url,
          title: title,
        }
      })
    }, 
  },
  created() {

  }
}
</script>

<style scoped lang="stylus">
  .comp-question
    width: 100%
    .header
      width: 100%
      height: 1rem
      line-height: 1rem
      background-color: #fff
      color: #333
      text-align: center
      font-size: .34rem
      position: absolute
      top: 0
      left: 0
      display: flex
      z-index: 99
      border-bottom: 1px solid #f5f5f5
      .back-btn
        position: absolute
        top: .3rem
        left: .3rem
        width: .38rem
        height: .38rem
        img
          display: block
          width: 100%
          height: 100%  
      .title
        width: 100%
        text-align: center
    .cont
      padding-top: 1rem
      background: #fff
      .pa-ins-faq-more 
        height: 1.02rem
        text-align: center
        line-height: 1rem
        border-bottom: 1px solid #efefef
        a 
          font-size: .28rem
          color: #666
      .hd
        height: 1.14rem
        line-height: 1.14rem
        padding: 0 .3rem
        font-size: .34rem
        font-weight: 500
      .bd 
        padding: 0 .3rem .3rem
        .pa-ins-faq 
          position: relative
          dl 
            padding-left: .8rem
            border-bottom: 1px solid #efefef
            dt 
              position: relative
              font-size: .3rem
              span 
                display: block
                min-height: .6rem
                padding: .28rem .3rem .28rem 0
                overflow: hidden
              em 
                display: block;
                position: absolute;
                top: .3rem;
                left: -.8rem;
                width: .5rem;
                height: .47rem;
                font-size: .24rem
                line-height: .4rem
                text-align: center;
                color: #fff;
                background: url(../../assets/images/faq_icon.png) no-repeat;
                background-size: cover;
            dd
              padding-bottom: .3rem
              font-size: .28rem
              line-height: .44rem
              color: #666
          dl:last-child 
              border: 0;
        
</style>
